import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Auth } from '../../../helpers'
import UserMenu from './UserMenu'
import './styles.css'

class NavAccount extends Component {
  constructor (props) {
    super(props)

    this.state = {
      expanded: false
    }

    this.expandUserMenu = this.expandUserMenu.bind(this)
  }

  expandUserMenu () {
    this.setState({ expanded: !this.state.expanded })
  }

  render () {
    const accounts = this.props.auth.user
      ? (this.props.auth.user.social_accounts || {})
      : {}
    const avatar = this.props.auth.user ? this.props.auth.user.avatar : ''

    return (
      <div className='nav-account'>
        <div className='nav'>

          {accounts.linkedin && (
            <div className='item'>
              <a href={accounts.linkedin.publicProfileUrl} className='link'>
                <img alt='' src='/imgs/social-in.png' width={29} height={46} />
                <span className='synced'><img alt='' src='/imgs/synced.png' /></span>
              </a>
            </div>
          )}

          {/* {accounts.facebook && (
            <div className='item'>
              <a href='' className='link'>
                <img alt='' src='/imgs/social-f.png' width={29} height={46} />
                <span className='synced'><img alt='' src='/imgs/synced.png' /></span>
              </a>
            </div>
          )} */}

          <div className='item'>
            <a href='' className='link'>
              <img alt='' src='/imgs/social.png' width={29} height={46} />
              <span className='referal'><img alt='' src='/imgs/referal.png' /></span>
              <span className='num'>{this.props.inviteBadges.length}</span>
            </a>
          </div>

        </div>
        <div className='divider'>|</div>
        <div className='user'>
          <div className='user-photo'
            style={{ background: `url(${avatar || '/imgs/default-avatar.png'}) no-repeat center /cover` }}><img alt='' /></div>
          <div className='user-info'>
            <span className='user-name cursor-pointer' onClick={this.expandUserMenu}>{Auth.getName()}</span>
            {this.state.expanded && <UserMenu dismiss={() => this.setState({ expanded: false })} />}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    inviteBadges: state.badges.inviteBadges
  }
}

export default connect(mapStateToProps)(NavAccount)



// WEBPACK FOOTER //
// ./src/components/common/header/NavAccount.js